"use strict";
exports.__esModule = true;
var redux_form_1 = require("redux-form");
var multiChange = function (form, fields) { return function (dispatch) {
    for (var field in fields) {
        dispatch((0, redux_form_1.change)(form, field, fields[field]));
    }
}; };
exports["default"] = multiChange;
